module.exports = __webpack_public_path__ + "static/lepaAbacus-1b145e8b29135ac315f445b602d15ddc.png";